/**
 * Constants for Absolutely feature
 */

// Threshold for detecting if ship is at an island (used for ship click detection and popup logic)
export const SHIP_AT_ISLAND_THRESHOLD = 0.15;

// Ship position offset from island (slightly before island to not cover island titles)
export const SHIP_POSITION_OFFSET = 0.2;
